import React from 'react';
import PageTemplate from '../../../components/template/PageTemplate';
import { RECOMMEND_PRODUCT_PAGE_NAME } from '../../../constants/service/app/recommendProductConstants';
import RecommendProductListContainer from '../../../containers/recommend/product/RecommendProductListContainer';

const RecommendProductList = () => {
  return (
    <PageTemplate pageName={RECOMMEND_PRODUCT_PAGE_NAME.RECOMMEND_PRODUCT_LIST}>
      <RecommendProductListContainer />
    </PageTemplate>
  );
};

export default RecommendProductList;
